export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const PANEL_WEB_APP_URL = import.meta.env.VITE_PANEL_WEB_APP_URL;
export const VERIFICATION_API_BASE_URL = import.meta.env.VITE_VERIFICATION_API_BASE_URL;
export const COUNTRY = "/seller/country";
export const SELLER_SEND_MOBILE_OTP = "/seller/mobile/otp/send";
export const SELLER_SEND_EMAIL_OTP = "/seller/email/otp/send";
export const SELLER_VERIFY_MOBILE_OTP = "/seller/mobile/otp/verify";
export const SELLER_VERIFY_EMAIL_OTP = "/seller/email/otp/verify";
export const SELLER_PERSONAL_INFORMATION_VALIDATE = "/seller/personal-information/validate";
export const SELLER_COMPANY_INFORMATION_VALIDATE = "/seller/company-information/validate";
export const SELLER_REGISTRATION = "/seller/register";
export const CONTACT_US = "seller/contact-us";
export const BUSINESS_TYPES_LIST = "/seller/business-types/list";
export const COUNTRY_LIST = "seller/country/list";
export const STATES_LIST = "seller/states/list";
export const AGENTS_LIST = "seller/agents/list";
export const AGENT_PERSONAL_INFORMATION_VALIDATE = "/agent/personal-information/validate";
export const AGENT_ADDRESS_INFORMATION_VALIDATE = "/agent/address-information/validate";
export const AGENT_SEND_MOBILE_OTP = "/agent/mobile/otp/send";
export const AGENT_SEND_EMAIL_OTP = "/agent/email/otp/send";
export const AGENT_VERIFY_MOBILE_OTP = "/agent/mobile/otp/verify";
export const AGENT_VERIFY_EMAIL_OTP = "/agent/email/otp/verify";
export const AGENT_REGISTRATION = "agent/register";
export const SELLER_KYC_DOCUMENT_UPLOAD = "/api/v1/seller/upload-kyc-document";
export const VERIFY_DRIVING_LICENSE = "driving-license-verify";
export const VERIFY_GSTIN_NUMBER = "gstin-verify";
export const VERIFY_IEC_CODE = "iec-verify";
export const VERIFY_BANK_DETAILS = "bank-verify";
export const AADHAAR_INFORMATION_VALIDATE = "aadhaar-verify";
export const PAN_INFORMATION_VALIDATE = "pan-verify";
export const AADHAAR_OTP_VALIDATE = "verify-aadhaar-otp";
export const PAN_OTP_VALIDATE = "verify-pan-otp";
